import { z } from 'zod';
// ---------------------------------------------------------------------------
// AuthResult — discriminated union (architecture spec)
// ---------------------------------------------------------------------------
const AuthSuccessSchema = z.object({
    authenticated: z.literal(true),
    method: z.enum(['jwt', 'api_key']),
    userId: z.string(),
    sessionId: z.string().optional(),
    apiKeyId: z.string().optional(),
});
const AuthFailureSchema = z.object({
    authenticated: z.literal(false),
    reason: z.enum([
        'no_token',
        'invalid_token',
        'expired_token',
        'jwks_fetch_failed',
        'key_revoked',
        'key_not_found',
        'clock_skew',
    ]),
});
export const AuthResultSchema = z.discriminatedUnion('authenticated', [
    AuthSuccessSchema,
    AuthFailureSchema,
]);
// ---------------------------------------------------------------------------
// API Key Payload
// ---------------------------------------------------------------------------
export const ApiKeyPayloadSchema = z.object({
    keyId: z.string(),
    userId: z.string(),
    name: z.string(),
    prefix: z.string(),
    hashedKey: z.string(),
    scopes: z.array(z.string()),
    createdAt: z.string().datetime(),
    expiresAt: z.string().datetime().optional(),
});
// ---------------------------------------------------------------------------
// Device Auth Session
// ---------------------------------------------------------------------------
export const DeviceAuthSessionSchema = z.object({
    deviceCode: z.string(),
    userCode: z.string(),
    verificationUri: z.string().url(),
    expiresAt: z.string().datetime(),
    interval: z.number().int().positive(),
    status: z.enum(['pending', 'approved', 'used', 'expired']),
});
// ---------------------------------------------------------------------------
// JWT Claims
// ---------------------------------------------------------------------------
export const JwtClaimsSchema = z.object({
    sub: z.string(),
    iat: z.number(),
    exp: z.number(),
    iss: z.string(),
    azp: z.string().optional(),
    sid: z.string().optional(),
    nbf: z.number().optional(),
});
// ---------------------------------------------------------------------------
// Credentials File (local filesystem — ~/.agentbrush/credentials.json)
// ---------------------------------------------------------------------------
export const CredentialsFileSchema = z.object({
    version: z.literal(1),
    api_key: z.string().regex(/^ab_live_[a-f0-9]{32}$/),
    api_base: z.string().url().default('https://api.agentbrush.dev'),
    user_id: z.string().optional(),
    plan: z.string().optional(),
    created_at: z.string().datetime(),
    last_used_at: z.string().datetime().optional(),
});
//# sourceMappingURL=auth.js.map